module.exports = __webpack_public_path__ + "static/media/reasons-background.82743b2f.png";